// wwwroot/js/src/index.js

// esbuild 会把 ark-floating.js 的内容（以及它引用的 floating-ui 库）全部打进来
import './ark-floating.js';

// 自定义拖放函数
import './ark-sortable';
import './ark-theme.js';
// 动效开关（data-motion）。排在其他模块前：ark-floating / ark-swipe-action 运行时会查 ArkUI.Motion
import './ark-motion.js';
import './ark-scrollbar.js';
import './ark-device.js';
import './ark-drawer.js';

// 软键盘：键盘是覆盖层、WebView 不变矮，按区域避让（Android POS 原生调 ArkUI.Keyboard.set 上报高度即启用）
import './ark-keyboard.js';

// 系统返回键 → 关闭最上层浮层（宿主须显式 ArkUI.BackStack.enable()）
import './ark-back-stack.js';
import './ark-tabs.js';
import './ark-swipe-action.js';

// 台号平面图
import './ark-floor-plan.js';

// 全局键盘快捷键
import './ark-shortcuts.js';

// 表格行内「点击单元格直接编辑」键盘 + 焦点桥
import './ark-table-inline.js';

// 你可以在这里添加更多文件...
console.log('Ark.UI JS Bundle Loaded');